import React, { useEffect } from "react";
import "./products.css";

import ReactPlayer from "react-player";

import LMS1 from "../../assets/videos/products/lms1.mp4";
import LMS2 from "../../assets/videos/products/lms2.mp4";
import LMS3 from "../../assets/videos/products/lms3.mp4";
import LMS4 from "../../assets/videos/products/lms4.mp4";

import AOS from "aos";
import "aos/dist/aos.css";

const LMS = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);
  return (
    <>
      <div className="products-banner lms">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div className="heading" data-aos="fade-up" data-aos-duration="1500">
              <div className="heading-flex">
                <h2>Learning Management System</h2>
                <h4>
                  Ready to enhance your organization's learning experience?{" "}
                  <br /> With Fidus LMS, the possibilities are limitless. Let's
                  explore the features that enable it all.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="products-section">
        <div className="products-banner-circle"></div>
        <div className="products-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-right" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Customization & Branding</h2>
                    <p>
                      Fidus LMS offers complete white labeling and customization
                      options, ensuring alignment with employer branding. Every
                      aspect, from features to color schemes to customizable
                      themes, can be tailored to reflect the organization's
                      identity.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="player" data-aos="fade-left" data-aos-duration="1500">
                  <video autoPlay loop controlsList="nodownload" muted>
                    <source src={LMS1} />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content-reverse">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5">
                <div className="player" data-aos="fade-right" data-aos-duration="1500">
                  <video autoPlay loop controlsList="nodownload" muted>
                    <source src={LMS2} />
                  </video>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-left" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Administrative Automation</h2>
                    <p>
                      Fidus LMS streamlines learning program execution by
                      automating administrative tasks like course marketing,
                      learner notifications, and completion reminders. This
                      ensures a seamless learning journey for employees.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-right" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Comprehensive Learning Features</h2>
                    <p>
                      The platform supports blended learning with integrated
                      virtual classrooms for instructor-led training and
                      discussions, automatic course deactivation, and an e-store
                      for easy access to learning resources. Responsive design,
                      and an easy course creation process enhance user
                      experience. Additionally, customizable certificates,
                      reports, and analytics provide valuable insights into
                      learner progress and course effectiveness, with support
                      for SCORM package 1.2.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="player" data-aos="fade-left" data-aos-duration="1500">
                  <video autoPlay loop controlsList="nodownload" muted>
                    <source src={LMS3} />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content-reverse">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5">
                <div className="player" data-aos="fade-right" data-aos-duration="1500">
                  <video autoPlay loop controlsList="nodownload" muted>
                    <source src={LMS4} />
                  </video>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="products-main">
                  <div className="products-main-content" data-aos="fade-left" data-aos-duration="1500">
                    <h2>Ongoing Enhancements</h2>
                    <p>
                      Fidus LMS continuously evolves to meet the needs of modern
                      workplaces. This includes integration of payment gateways
                      for seamless transactions and continuous improvements such
                      as enhanced reports, easy course access, and advanced
                      analytics for personalized insights.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LMS;
